import styled from 'styled-components';
import { compose, textAlign, TextAlignProps, width } from 'styled-system';

import { TableBuilderColumnProps } from '../TableBuilderColumn';

export const StyledDefaultHeaderCell = styled.th<TextAlignProps & Pick<TableBuilderColumnProps<unknown>, 'width'>>`
    padding: 20px 16px;

    ${compose(textAlign, width)}
`;
